import {Model, ModelMixin} from '../../common/model.class';
import {Address} from '../../common/values/address.class';
import {InstitutionContact} from '../common/values/institution-contact.class';
import {AttendanceDuration} from '../common/values/attendance-duration.class';
import moment = require('moment');
import Moment = moment.Moment;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class MedicalEducation extends ModelMixin() implements Model<MedicalEducation> {

    TYPE = MedicalEducation;

    institution?: string;
    contact: InstitutionContact = new InstitutionContact();
    address: Address = new Address();
    degree?: string;
    graduationDate?: Moment;
    attendance: AttendanceDuration = new AttendanceDuration();
    completedInUSA?: boolean;

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.graduationDate) jsonData.graduationDate = moment(jsonData.graduationDate);
        if (jsonData.attendance) jsonData.attendance = new AttendanceDuration(jsonData.attendance);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/education/medical/medical-education.model.ts